<!-- CHAT -->
<div class="chat">

  <div *ngIf="isDialog" class="diag-header">
    <h1 class="font-weight-600">{{ 'DIALOGS.TITLES.COMMENTS' | translate }}</h1>
    <button mat-raised-button color="primary" (click)="onDismiss()">
      <!-- <mat-icon>close</mat-icon> -->
      {{'DIALOGS.ACTIONS.CLOSE' | translate}}
    </button>
  </div>
  <!-- CHAT CONTENT -->
  <div id="chat-content">

    <!-- CHAT MESSAGES -->
    <div class="chat-messages">

      <!-- MESSAGE -->
      <div *ngFor="let message of comments; let i = index" class="message-row" [ngClass]="{
                          'me': message.createdBy !== null,
                          'contact': message.createdBy === null,
                          'first-of-group': true,
                          'last-of-group': true
                          }">
        <div class="space-b">
          <div class="bubble" [ngClass]="{'primary': message.createdBy === null}">
            <div class="space-b">
              <div class="message">{{message.comment}}</div>
            </div>

            <div *ngIf="!isDialog" class="time">
              <span class="mr-8">{{message.createdBy || ('BUTTONS.CHAT-ALERTER' | translate)}}</span>
              <span>{{message.createdDate | date:'short'}}</span>
            </div>
          </div>
          <button *ngIf="message.id == 0" mat-icon-button class="delete-msg"
            matTooltip="{{'BUTTONS.DELETE' | translate}}" (click)="deleteMessage(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

      </div>
      <!-- / MESSAGE -->

    </div>
    <!-- CHAT MESSAGES -->

  </div>
  <!-- / CHAT CONTENT -->

  <!-- CHAT FOOTER -->
  <div class="chat-footer mat-elevation-z6" fxFlex="0 0 auto" fxLayout="column">

    <!-- REPLY FORM -->
    <div class="reply-form" fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="center center">

      <form #replyForm="ngForm" class="" fxFlex fxLayout="row" fxLayoutAlign="start center"
        [ngStyle]="{'filter' : editable ? 'opacity(1)':'opacity(0.5);'}">

        <mat-form-field appearance="outline" class="" fxFlex floatLabel="never">
          <!--appearance="standard"-->
          <div class="mr-32">
            <textarea matInput #commentText [disabled]="loading || !editable"
              placeholder="{{'BUTTONS.CHAT-INPUT' | translate}}" ngModel name="commentText" [rows]="1" class="m-8"
              (keydown.enter)="addComment(commentText.value); commentText.value = ''; $event.preventDefault();"></textarea>
          </div>
        </mat-form-field>

        <button class="mb-1 send-message-button" mat-icon-button color="primary" type="submit" aria-label="Send message"
          (click)="addComment(commentText.value); commentText.value = ''" [disabled]="loading || !editable">
          <mat-icon class="" [ngClass]="{'secondary-text' : !editable}">send</mat-icon>
        </button>

      </form>

    </div>
    <!-- / REPLY FORM -->
  </div>
  <!-- / CHAT FOOTER-->
</div>
<!-- / CHAT -->